import Vue from 'vue'
import R from 'ramda'
import debounce from 'lodash.debounce'
import tap from 'tap-logger'
import {selectSlider} from '../../theme-helpers'
import StickerMessagePreview from '../components/sticker-message-preview.vue'

const toSlug = R.pipe(
	maybeString => typeof maybeString === 'string' ? maybeString : '',
	R.split('-'),
	R.join('_')
)

export const singleApplicationVue = {
	el: '#single-application-vue',
	components: {
		StickerMessagePreview
	},
	data: {
		sticker_text: [],
		actual_input: '',
		sticker_text_1: '',
		sticker_text_2: '',
		selects: {
			designsSelect: {},
			formsSelect: {},
			templatesSelect: {},
			fontsSelect: {},
		},
		selectedDesign: {},
		selectedForm: {},
		selectedTemplate: {},
		selectedLabel: {},
		formsCache: {},
		someCache: {},
		loadedFonts: [],
		sticker_col_styles: { // de los stickers que se muestran del lado derecho, para editar editar el texto
			height: 0,
			width: 0
		},
		quantity: '',
		modal: false,
		lineNumber: 0,
		maxCharacters: 2,
		minimumFontSizeConfig: 10, //px, sólo config
		fontSizes: {},
		fontSize: 8,
		maxFontSize: 12,
		minSize:0,
		formIsDisabled: false, //después de la compra se deshabilita el botón
		spaceToSelect: null,
		/* userTextConfirmation: { // de los stickers que se muestran del lado derecho, para editar editar el texto
			value: false,
			error: true
		}, */
	},

	computed: {
		availableForms() {
			let key = toSlug(R.path(['selectedDesign', 'slug'], this))
			return R.pathOr([], ['formsCache', key], this)
		},

		stickerText() { //concatenamos para correr el watcher
			var text = "";
			for (var i = 0; i < this.sticker_text.length; i++) {

				text += this.sticker_text[i];
			}

			return text
		},

		selectedFont() {
			return R.pathOr('', ['selectedLabel', 'font', 'google_label'], this)
		},

		selectedSku() {
			return R.pathOr({}, ['selectedLabel', 'sku'], this)
		},

		minFontSize() {
			return R.pipe(
				R.values,
				R.reduce(R.min, Infinity),
			)(this.fontSizes)
		},

		minFontSizeExceeded() {

			return this.actual_input.length > this.maxCharacters
		}
	},

	methods: {
		pathOr: R.pathOr,

		isEmpty: R.isEmpty,

		getThumbnail: obj => R.pathOr('', ['thumbnail_image', 'url'], obj) || '/images/not-available.png',

		getAlt: R.path(['thumbnail_image', 'alt']),

		getTitle: R.path(['thumbnail_image', 'title']),

		selectDesign(design) {
			this.calculateHeight();

			this.selectedDesign = design
			if (this.formsCache[toSlug(design.slug)]) {
				//no hacemos nada porque availableForms se encarga de eso
				return
			}
			this.getForms(design)
		},

		//Función que calcula la altura para no provocar un "salto" cuando se cambia de forma
		calculateHeight(){
			let sum_all_spaces = 0;

			//Para obtener la altura, necesitamos los divs que contienen el título, la descripción y el precio
			//Cada uno de estos, tiene una clase helper. Al obtenerlos sumamos las alturas para obtener el espacio antes del select	de formas
			document.querySelectorAll('.help-label').forEach(function(element) {
			   	sum_all_spaces += element.offsetHeight;
			});

			//Si es movil, la altura puede variar, ya que el div del visualizador, se posiciona arriba del título y éste también cambia de tamaño al
			//cargar la forma
			if (window.innerWidth < 992) {
				//Obtenemos el contenedor del visualizador
				let wrap_space = document.getElementsByClassName('container-helper')[0].offsetHeight;
				console.log('wrap_space');
			    console.log(wrap_space);
				//Restamos el min height al tamaño del contendor
			   // wrap_space -= 88;

			    //Se lo agregamos a la sumatoria de elementos
			    sum_all_spaces += wrap_space;

			}

			console.log('sum_all_spaces');
			console.log(sum_all_spaces);
			this.spaceToSelect = sum_all_spaces + 'px';
		},

		getForms(design) {

			this.$http.get(design.public_url)
				.then(R.pathOr([], ['body']))
				.then(collection => {

					this.$set(`formsCache.${toSlug(design.slug)}`, collection)

					//al agregar los datos al cache, availableForms se encarga de mostrarlas

					return collection
				})
				.catch(this.$root.ajaxErrAlerting)

		},

		selectForm(form) {
			this.selectedForm = form

		},

		selectTemplate(template) {
			this.selectedTemplate = template
		},

		selectLabel(label) {
			this.selectedLabel = label
		},

		selectedClass(elem, selectedElem) {
			return R.equals(elem, selectedElem) ?
				'selected' :
				''
		},

		validateFontsize(e) {
			this.actual_input = e.target.value;
			//Si this.minimumFontSize es excedido, evitamos que el usuario pueda ingresa más texto
			if (e.keyCode === 8) {
				return
			} // Delete, para permitir que el usuario borre sin problemas
			if (this.minFontSizeExceeded) {
				e.preventDefault()
			}
		},

		resizeFont: debounce(function() {
			if (0 === R.pathOr(0, ['selectedTemplate', 'stamps', 'length'], this)) {
				return
			}
			this.$broadcast('resize-font') //delegamos resizeFont a los hijos, porque pueden tener contenedores de tamaño distinto
		}, 70),

		addToCart() {

			let data = this.getData()

			/* if( this.userTextConfirmation.error ){
				return
			} */

			this.$http.post(this.store.routes.addToCart.post, data)
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.store.menus.cart.isOpen = true;
					this.store.cart.data = body.data
					this.modal = false
					//this.alert(body)
				})
				.catch(this.$root.ajaxErrAlerting)

		},

		openModal() {

			let data = this.getData()

			let validation = R.pipe(
				R.pick(['texts', 'sku', 'quantity']),
				R.evolve({ // validamos las propiedades seleccionadas arriba
					texts: texts => R.all(R.isEmpty, texts) ? '' : '',
					sku: sku => R.isNil(sku) ? 'Es necesario elegir diseño, forma, color y fuente' : '',
					quantity: quantity => tap(quantity) === '0' || R.isNil(quantity) || R.isEmpty(quantity) ? 'Es necesario elegir una cantidad mayor a 0' : '',
				}),
				R.values,
				errs => this.minFontSizeExceeded // validamos el tamaño de fuente
				?
				errs.concat('El tamaño de letra excede el mínimo, es necesario reducir la extensión del texto ingresado.') :
				errs,
				// errs => this.userTextConfirmation !== true // validamos que el usuario haya seleccionado el checkbox de confirmación
				// ?
				// errs.concat('Es necesario confirmar que el texto provisto es correcto.') :
				// errs,
				R.reject(R.isEmpty),
			)(data)

			if (this.formIsDisabled) { // validamos que no se haya ya agregado el sticker al carrito
				this.alertError(['Ya has efectuado la compra de este sticker, si deseas volver a comprarlo, por favor recarga la página.'])
				return
			}
			if (validation.length > 0) {
				this.alertError(validation)
				return
			}

			this.modal = true
		},

		closeModal() {
			this.modal = false
		},

		/* agreeTexts(){
			this.userTextConfirmation.error = this.userTextConfirmation.value;
			this.userTextConfirmation.value = !this.userTextConfirmation.value;
		}, */

		getData() {

			return {
				stamps: this.fontSizes,
				texts: this.sticker_text,
				sku: this.selectedSku.sku,
				quantity: this.quantity,
				_token: this.store.csrf_token,
			}
		}
	},

	watch: {
		//Cuando se selecciona un Diseño, siempre que sea posible (cuando los elementos existan), se seleccionara el primer elemento de cada uno de los selects
		'store.designs.data': {
			initial: true,
			handler: function() {

				if (R.pathOr([], ['store', 'designs', 'data', 'length'], this) > 0) {
					this.designsSelect = selectSlider('#designs_select_JS')

					this.selectDesign(this.store.designs.data[0])
				}
			}
		},

		availableForms() {
			this.formsSelect = selectSlider('#forms_select_JS')
			this.selectForm(R.pathOr({}, ['availableForms', 0], this))
		},

		selectedForm() {

			if(this.selectedForm.sets){
				this.lineNumber = this.selectedForm.sets[0].line_number;
				this.maxCharacters = this.selectedForm.sets[0].max_characters;
				this.maxFontSize = this.selectedForm.sets[0].font_size_max;

	            this.minSize = this.selectedForm.sets[0].font_size;

				this.fontSize = this.selectedForm.sets[0].font_size;
			}else{
				this.lineNumber = this.selectedForm.line_number;
				this.maxCharacters = this.selectedForm.max_characters;
				this.maxFontSize = this.selectedForm.font_size_max;

	            this.minSize = this.selectedForm.font_size;

				this.fontSize = this.selectedForm.font_size;
			}
			var tempTexts = this.sticker_text;

			for (var i = 0; i < this.lineNumber; i++) {

				if (tempTexts[i] != undefined) {
					Vue.set(this.sticker_text, i, tempTexts[i]);
				} else {
					Vue.set(this.sticker_text, i, "");
				}


			}


			// if ((typeof this.selectedTemplate.thumbnail_image) == undefined) {

			// 	$(".sticker-wrap").css("background-image", `url(${this.selectedForm.background_image.url})`);
			// }
			Vue.nextTick(() => {
				this.templatesSelect = selectSlider('#templates_select_JS')
				this.selectTemplate(R.pathOr({}, ['selectedForm', 'templates', 0], this))
			})
		},

		selectedTemplate() {

			this.loadedFonts = R.pipe(
				R.pathOr([], ['labels']),
				R.map(R.path(['font', 'google_url'])),
				R.reject(R.isEmpty),
				R.concat(this.loadedFonts),
				R.uniq,
			)(this.selectedTemplate)

			Vue.nextTick(() => {

				// if (!typeof this.selectedTemplate.thumbnail_image !== undefined) {
				// 	$(".sticker-wrap").css("background-image", "url('"+this.selectedTemplate.background_image.url+"')");

				// }
				this.selects.fontsSelect = selectSlider('#fonts_select_JS')
				this.selectLabel(R.pathOr({}, ['selectedTemplate', 'labels', 0], this))
				this.resizeFont()
			})
		},

		stickerText() {
			this.resizeFont()
		},

		selectedFont() {
			this.resizeFont()
		}
	},

	events: {
		'new-font-size'({
			id,
			font_size
		}) {
			let currentStamps = R.map(stamp => stamp.id, R.pathOr([], ['selectedTemplate', 'stamps'], this))

			this.fontSizes = R.pipe(
				R.assoc(id, font_size),
				R.pick(currentStamps),
			)(this.fontSizes)

		}
	},

}



// WEBPACK FOOTER //
// ./resources/assets/js/vue/main/single-application.js